import KlientkontoerklaeringForm from "../../components/klientkontoerklaering/KlientkontoerklaeringForm";
import { KKE_FORM_INITIAL_VALUES } from "../../constants/klientkontoerklaering/initialValues";

export default function KlientkontoerklaeringDesign() {
  return (
    <div className="container-xxl mt-3 mb-7">
      <KlientkontoerklaeringForm
        id={""}
        initialValues={KKE_FORM_INITIAL_VALUES}
        kke={{
          antalAdvokater: 1,
          antalAdvokaterSigneret: 0,
          firmaId: "",
          formular: "",
          formularType: "Formular1",
          frist: "",
          id: "",
          indsendt: "",
          interessentSigneret: false,
          jsonData: "",
          loginToken: "",
          personId: "",
          revisorId: "",
          revisorSigneret: false,
          revisorSigneretAf: "",
          sidstAendret: "",
          signeret: false,
          signeretAf: "",
          status: "Kladde",
          kanErklaeringOpdateres: true,
          klienterklaeringType: "LoebendeErklaering",
          periodeFraDato: "2001-01-01",
          periodeTilDato: "2002-01-01",
          periodeTilDatoMinusEnDag: "2001-12-31",
          interessentKlienterklaeringMode: "IkkeInteressentKlienterklaering",
        }}
        metadata={{
          person: { navn: "Design Designesen" },
          startDato: "2021-01-01",
          slutDato: "2021-12-31",
          fristDato: "2022-03-31",
        }}
        formularType="Formular1"
      />
    </div>
  );
}
